import React from 'react';
import CampaignEditor from './CampaignEditor';

export default function DuplicateCampaign(props) {
    return <CampaignEditor {...props} mode="duplicate"/>;
}
